<template>
  <div id="List" class="list-container">
    <SovecoNavBar />
    <modal name="floatmap" :draggable="false">
      <div v-if="clickRow !== null" class="floatMapWin">
        <div class="floatMap">
          {{ clickRow.targa }}
          <div class="is-pulled-right">
            <button @click="goMap(clickRow)">Mappa</button>
            <button @click="hideMap">Chiudi</button>
          </div>
        </div>
        <GmapMap id="gmap" class="map-container" :center="center" :zoom="zoom">
          <GmapMarker
            :position="{
              lat: parseFloat(clickRow.latitude),
              lng: parseFloat(clickRow.longitude),
            }"
            :draggable="false"
          />
        </GmapMap>
      </div>
    </modal>
    <modal name="floatveh" :draggable="true">
      <div v-if="vehicleSel !== null" class="floatMapWin">
        <div class="floatMap">
          {{ clickRow.targa }}&nbsp;{{ vehicleSel.autista }}
          <div class="is-pulled-right">
            <button @click="goVeh(clickRow)">Scheda</button>
            <button @click="hideVeh">Chiudi</button>
          </div>
          <div class="infoWin">
            <table>
              <tr>
                <td>Tipo</td>
                <td>{{ vehicleSel.tipo }}</td>
              </tr>
              <tr>
                <td>Marca</td>
                <td>{{ vehicleSel.marca }}</td>
              </tr>
              <tr>
                <td>Modello</td>
                <td>{{ vehicleSel.modello }}</td>
              </tr>
              <tr>
                <td>Colore</td>
                <td>{{ vehicleSel.colore }}</td>
              </tr>

              <tr v-if="hasSondeCarb(vehicleSel)">
                <td>Totale Carburante</td>
                <td>{{ clickRow.v0 }}&nbsp;L</td>
              </tr>
              <tr>
                <td v-if="checkSonda(1, 'C')">
                  Sonda 1 :&nbsp;{{ clickRow.v1 | sondenull_filter }}&nbsp;L
                </td>
                <td v-if="checkSonda(2, 'C')">
                  Sonda 2 :&nbsp;{{ clickRow.v2 | sondenull_filter }}&nbsp;L
                </td>
              </tr>
              <tr>
                <td v-if="checkSonda(3, 'C')">
                  Sonda 3 :&nbsp;{{ clickRow.v3 | sondenull_filter }}&nbsp;L
                </td>
                <td v-if="checkSonda(4, 'C')">
                  Sonda 4 :&nbsp;{{ clickRow.v4 | sondenull_filter }}&nbsp;L
                </td>
              </tr>
              <tr>
                <td v-if="checkSonda(1, 'T')">
                  Sonda 1 :&nbsp;{{ clickRow.v1 | sondenull_filter }}&nbsp;C°
                </td>
                <td v-if="checkSonda(2, 'T')">
                  Sonda 2 :&nbsp;{{ clickRow.v2 | sondenull_filter }}&nbsp;C°
                </td>
              </tr>
              <tr>
                <td v-if="checkSonda(3, 'T')">
                  Sonda 3 :&nbsp;{{ clickRow.v3 | sondenull_filter }}&nbsp;C°
                </td>
                <td v-if="checkSonda(4, 'T')">
                  Sonda 4 :&nbsp;{{ clickRow.v4 | sondenull_filter }}&nbsp;C°
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </modal>
    <!-- <div style="display: flex; flex-direction: column"> -->
    <template v-if="lastPos !== null">
      <VueScrollTable :options="options" :columns="columns" :rows="lastPos" />
    </template>
    <!-- </div> -->
  </div>
</template>
<script>
import { ServiceBus } from '../ServiceBus.js'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
import VueScrollTable from './reusable/VueScrollTable.vue'

export default {
  name: 'List',
  components: {
    VueScrollTable,
  },
  mixins: [UtilityMixin],
  data() {
    return {
      zoom: 12,
      center: {
        lat: 45,
        lng: 11,
      },
      clickRow: null,
      vehicleSel: null,
      api_server: '',
      prefs: null,
      auth: null,
      windowHeight: 0,
      lastPos: [],
      sonde_cols: [],
      columns: [],
      options: {
        id: 'LS001',
        isResizeable: true,
        isSelectable: true,
        cssContainer: 'table-flex-container',
        cssHeader: 'table_list_header',
        cssBody: 'table_list',
        cssRows: 'table_list',
        order_col: 'targa',
      },
      updateInterval: null,
      editOn: false,
    }
  },

  beforeRouteLeave(to, from, next) {
    const vm = this
    let myCookie = {
      order_col: vm.options.order_col,
      columns: vm.columns,
    }
    this.$cookies.set(this.options.id, JSON.stringify(myCookie), 365)
    vm.doUpdateLastPos(false)
    window.removeEventListener('resize', this.getWindowHeight)
    next()
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    ServiceBus.setApi(vm.api_server)
    ServiceBus.setAuth(vm.auth)
    if (vm.auth === null) {
      vm.$router.push({
        path: 'login',
      })
    }
    vm.initColumns()
    vm.$nextTick(function () {
      window.removeEventListener('resize', null)
      window.addEventListener('resize', vm.getWindowHeight)
      vm.doGetLastPos().then(() => {
        vm.getWindowHeight()
        vm.doUpdateLastPos(true)
      })
    })
  },
  methods: {
    hideMap() {
      this.$modal.hide('floatmap')
    },
    showMap() {
      this.$modal.show('floatmap')
      //Vue.$gmapDefaultResizeBus.$emit('resize');
    },
    goMap(row) {
      this.$localStorage.set('vehicles_cod', row.cod)
      this.$router.push('Map')
    },
    hideVeh() {
      this.$modal.hide('floatveh')
    },
    showVeh() {
      this.$modal.show('floatveh')
    },
    goVeh(row) {
      this.$localStorage.set('vehicles_cod', row.cod)
      this.$router.push('Vehicles')
    },

    checkSonda(n, t) {
      const vm = this
      let b
      switch (n) {
        case 1: {
          b = vm.clickRow.sonda_1 === t
          break
        }
        case 2: {
          b = vm.clickRow.sonda_2 === t
          break
        }
        case 3: {
          b = vm.clickRow.sonda_3 === t
          break
        }
        case 4: {
          b = vm.clickRow.sonda_4 === t
          break
        }
      }
      return b
    },

    initColumns() {
      let vm = this
      let col
      let columns = [
        {
          id: 'targa',
          search: true,
          ghostid: 'targaKey',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Targa',
          width: 80,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 0,
          image: false,
          calcColor: true,
        },
        {
          id: 'vei',
          visible: true,
          f_type_id: '',
          f_type: '*',
          mousefeedback: true,
          title: 'V',
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          width: 40,
          elastic: false,
          filter: '',
          order: -1,
          image: true,
          image_name: '',
        },
        {
          id: 'vehicle_id',
          visible: true,
          f_type_id: '',
          f_type: '*',
          mousefeedback: true,
          title: 'ID',
          alignment_th: 'center_align',
          alignment_td: 'left_align',
          width: 100,
          elastic: false,
          filter: '',
          order: 0,
          image: false,
          editable: true,
        },
        {
          id: 'drivername',
          search: true,
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Autista',
          width: 250,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'date',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Data',
          width: 150,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: 'date_reverse_filter',
          order: 1,
          image: false,
        },
        {
          id: 'guida',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Guida',
          width: 80,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'pausa',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Pausa',
          width: 80,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'speed',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'km/h',
          alignment_th: '',
          alignment_td: 'right_align',
          elastic: false,
          width: 60,
          filter: '',
          order: 1,
          image: false,
        },
        {
          id: 'gps',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Gps',
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          width: 60,
          elastic: false,
          filter: '',
          order: -1,
          image: true,
          image_name: '',
        },
        {
          id: 'message',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Messaggio',
          alignment_th: '',
          alignment_td: '',
          width: 200,
          elastic: true,
          filter: 'mssg_filter',
          order: 1,
          image: false,
        },
        {
          id: 'map',
          visible: true,
          f_type_id: '',
          f_type: '*',
          mousefeedback: true,
          title: 'M',
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          width: 40,
          elastic: false,
          filter: '',
          order: -1,
          image: true,
          image_name: 'images/earth-globe.png',
        },
        {
          id: 'gmap',
          visible: true,
          f_type_id: '',
          f_type: '*',
          mousefeedback: true,
          title: 'G',
          alignment_th: 'center_align',
          alignment_td: 'center_align',
          width: 40,
          elastic: false,
          filter: '',
          order: -1,
          image: true,
          image_name: 'images/gmap.jpeg',
        },
        {
          id: 'address',
          visible: true,
          f_type_id: '',
          f_type: '*',
          title: 'Località',
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          width: 600,
          filter: 'pipe_filter',
          order: -1,
          image: false,
        },
      ]

      if (
        vm.auth.sonde.c1 +
          vm.auth.sonde.c2 +
          vm.auth.sonde.c3 +
          vm.auth.sonde.c4 >
        1
      ) {
        col = {
          id: 'v0',
          visible: true,
          title: 'Tot',
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      let c = 0
      let t = 0
      if (vm.auth.sonde.c1 > 0) {
        c++
        col = {
          id: 'v1',
          visible: true,
          f_type_id: 'sonda_1',
          f_type: 'C',
          title: 'C ' + c,
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      if (vm.auth.sonde.c2 > 0) {
        c++
        col = {
          id: 'v2',
          visible: true,
          f_type_id: 'sonda_2',
          f_type: 'C',
          title: 'C ' + c,
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      if (vm.auth.sonde.c3 > 0) {
        c++
        col = {
          id: 'v3',
          visible: true,
          f_type_id: 'sonda_3',
          f_type: 'C',
          title: 'C ' + c,
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      if (vm.auth.sonde.c4 > 0) {
        c++
        col = {
          id: 'v4',
          visible: true,
          f_type_id: 'sonda_4',
          f_type: 'C',
          title: 'C ' + c,
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      if (vm.auth.sonde.t1 > 0) {
        t++
        col = {
          id: 'v1',
          visible: true,
          f_type_id: 'sonda_1',
          f_type: 'T',
          title: 'T ' + t,
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      if (vm.auth.sonde.t2 > 0) {
        t++
        col = {
          id: 'v2',
          visible: true,
          f_type_id: 'sonda_2',
          f_type: 'T',
          title: 'T ' + t,
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      if (vm.auth.sonde.t3 > 0) {
        t++
        col = {
          id: 'v3',
          visible: true,
          f_type_id: 'sonda_3',
          f_type: 'T',
          title: 'T ' + t,
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      if (vm.auth.sonde.t4 > 0) {
        t++
        col = {
          id: 'v4',
          visible: true,
          f_type_id: 'sonda_4',
          f_type: 'T',
          title: 'T ' + t,
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      if (vm.auth.sonde.v1 > 0) {
        t++
        col = {
          id: 'v1',
          visible: true,
          f_type_id: 'sonda_1',
          f_type: 'T',
          title: 'T ' + t,
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      if (vm.auth.sonde.v2 > 0) {
        t++
        col = {
          id: 'v2',
          visible: true,
          f_type_id: 'sonda_2',
          f_type: 'T',
          title: 'T ' + t,
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      if (vm.auth.sonde.v3 > 0) {
        t++
        col = {
          id: 'v3',
          visible: true,
          f_type_id: 'sonda_3',
          f_type: 'T',
          title: 'T ' + t,
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      if (vm.auth.sonde.v4 > 0) {
        t++
        col = {
          id: 'v4',
          visible: true,
          f_type_id: 'sonda_4',
          f_type: 'T',
          title: 'T ' + t,
          alignment_th: 'center_align',
          alignment_td: 'right_align',
          width: 70,
          elastic: false,
          filter: 'sondenull_filter',
          order: 1,
          image: false,
        }
        columns.push(col)
      }
      vm.columns = columns
    },
    colSaveCell(colId, rowData) {
      if (colId === 'vehicle_id') {
        ServiceBus._doSaveVehicleID(rowData.cod, rowData.vehicle_id)
      }
    },
    colClick(id, col, row, event) {
      if (col.id === 'map') {
        if (row.oscurata) return
        this.center = {
          lat: parseFloat(row.latitude),
          lng: parseFloat(row.longitude),
        }
        this.clickRow = row
        this.showMap()
      }
      if (col.id === 'gmap') {
        if (row.oscurata) return
        window.open(
          'https://maps.google.com/maps?saddr=' +
            row.latitude +
            ',' +
            row.longitude +
            '&target=_blank'
        )
      }
      if (col.id === 'vei') {
        this.clickRow = row
        this.doGetVehicle(row.cod)
      }
      if (col.id === 'vehicle_id' && !this.editOn) {
        this.handleSetVehicleId(event, row)
      }
    },
    handleSetVehicleId(event, row) {
      this.editOn = true
      if (event.srcElement.firstChild) {
        event.srcElement.removeChild(event.srcElement.firstChild)
      }
      let x = document.createElement('INPUT')
      x.setAttribute('type', 'text')

      x.value = row.vehicle_id
      event.srcElement.appendChild(x)
      x.select()
      event.srcElement.onkeypress = function () {
        var event = window.event
        var btnPress = event.keyCode

        if (btnPress == 13) {
          removeEventListener('onkeypress', null)
        }
      }
    },
    get_image(id, value, row) {
      let img_link
      if (id === 'gps') {
        switch (parseInt(value)) {
          case 0:
            img_link = './images/gps_oke.png'
            break
          case 1:
            img_link = './images/gps_nok.png'
            break
        }
      }
      if (id === 'vei') {
        switch (row.mode_orig) {
          case 0:
            img_link = './images/truck.png'
            break
          case 1:
            img_link = './images/park.png'
            break
        }
      }
      return img_link
    },
    format_cell(value, filter) {
      let res = value
      let dd
      switch (filter) {
        case 'mssg_filter':
          if (!value) res = ''
          res = value.split('[')[0]
          break
        case 'pipe_filter':
          if (!value) res = '---'
          else res = value.replace(/\|/g, ' ')
          break
        case 'date_reverse_filter':
          if (!value) res = ''
          dd = value.split(' ')
          res = dd[0].split('-').reverse().join('-') + ' ' + dd[1]
          break
      }
      return res
    },
    async setAbbinamenti() {
      const vm = this
      const couples = await ServiceBus._doGetAbbinamenti(vm.prefs.distance)
      if (couples.length > 0) {
        vm.lastPos.forEach((element) => {
          let obj1 = couples.find((item) => item.vehicle1_cod == element.cod)
          if (obj1) {
            element.targaKey = obj1.vehicle1_targa + '|A|' + obj1.vehicle2_targa
            element.couple = obj1
            element.role = 1 // trattore
            element.rimorchio = vm.lastPos.find(
              (item) => item.cod == obj1.vehicle2_cod
            )
            element.rimorchio.role = 2
          }
          let obj2 = couples.find((item) => item.vehicle2_cod == element.cod)
          if (obj2) {
            element.targaKey = obj2.vehicle1_targa + '|B|' + obj2.vehicle2_targa
            element.couple = obj2
            element.role = 2 // rimorchio
          }
          if (obj1 === undefined && obj2 === undefined) {
            element.targaKey = element.targa + '|=|' + element.targa
            element.couple = []
            element.role = 0 // free
          }
        })
      } else {
        vm.lastPos.forEach((element) => {
          element.targaKey = element.targa
          element.couple = []
          element.role = 0 // free
        })
      }
    },
    doUpdateLastPos(isActive) {
      const vm = this
      if (isActive) {
        vm.updateInterval = setInterval(function () {
          vm.doGetLastPos()
        }, 120000)
      } else if (vm.updateInterval !== null) {
        clearInterval(vm.updateInterval)
        vm.updateInterval = null
      }
    },
    async doGetLastPos() {
      const vm = this
      let t
      vm.isLoading = true
      const rdata = await ServiceBus._doGetLastPos()
      vm.isLoading = false

      if (rdata.length > 0) {
        vm.lastPos = rdata
        vm.applicaOscuramentoPosizioni(vm.lastPos, vm.auth)
        for (let i = 0; i < vm.lastPos.length; i++) {
          vm.lastPos[i].drivername = vm.getDriverName(vm.lastPos[i])
          t = vm.calcDeltaTimeSpecial(vm.lastPos[i].time, vm.lastPos[i].date)
          if (vm.lastPos[i].mode == 0) {
            vm.lastPos[i].pausa = ''
            vm.lastPos[i].guida = t.s
            vm.lastPos[i].mode_orig = 0
          } else {
            vm.lastPos[i].guida = ''
            vm.lastPos[i].pausa = t.s
            vm.lastPos[i].mode_orig = 1
          }

          vm.lastPos[i].mode = t.m
        }
      }
      if (vm.prefs.coupling == 1) {
        await vm.setAbbinamenti()
      } else {
        vm.lastPos.forEach((element) => {
          element.targaKey = element.targa
          element.couple = []
          element.role = 0 // free
        })
      }
      ServiceBus.$emit('forcesort')
      console.log(vm.lastPos)
    },
    async doGetVehicle(cod) {
      const vm = this
      const rdata = await ServiceBus._doGetVehicle(cod)
      if (rdata) {
        this.vehicleSel = rdata
        this.showVeh()
      }
    },
    getWindowHeight(event) {
      this.windowHeight = document.documentElement.clientHeight
      // document
      //   .getElementById(this.options.id)
      //   .setAttribute('style', 'height:' + (this.windowHeight - 100) + 'px')
    },
    beforeDestroy() {
      const vm = this
      window.removeEventListener('resize', vm.getWindowHeight)
      vm.doUpdateLastPos(false)
    },
  },
}
</script>
